import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { Tooltip } from "../Tooltip";

interface CardActionsProps {
  /** The server's `can_split`: Split is offered only where it allows it (2.8 (7)). */
  canSplit: boolean;
  onConfirm: () => void;
  onShowAlternatives: () => void;
  onSplit?: () => void;
  /** The receipt button, last in the row. */
  children?: ReactNode;
}

/** A categorized top card's buttons: Confirm, Correct, Split, then the receipt. */
export function CardActions({
  canSplit,
  onConfirm,
  onShowAlternatives,
  onSplit,
  children,
}: CardActionsProps): ReactNode {
  return (
    <div className="card-actions">
      <Tooltip text="Confirming books this entry">
        <motion.button
          type="button"
          className="card-action-btn card-action-confirm"
          onClick={onConfirm}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Confirm categorization"
        >
          <span className="card-action-icon">&#10003;</span>
          Confirm
        </motion.button>
      </Tooltip>

      <Tooltip text="Choose a different account for this transaction">
        <motion.button
          type="button"
          className="card-action-btn card-action-correct"
          onClick={onShowAlternatives}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Choose different account"
        >
          <span className="card-action-icon">&#9998;</span>
          Correct
        </motion.button>
      </Tooltip>

      {canSplit && (
        <Tooltip text="Split this transaction across multiple accounts">
          <motion.button
            type="button"
            className="card-action-btn card-action-split"
            onClick={onSplit}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Split transaction"
          >
            <span className="card-action-icon">&#8644;</span>
            Split
          </motion.button>
        </Tooltip>
      )}

      {children}
    </div>
  );
}
